module.exports = __webpack_public_path__ + "media/gameover.b65e953c.wav";